import { type SalonStockerHttpTypes } from "@repo/api-sdk";
import { queryKeysFactory } from "../queryKeyFactory";

const ROOT_QUERY_KEY = "seller-offer" as const;
export const queryKeys = {
  ...queryKeysFactory<
    typeof ROOT_QUERY_KEY,
    SalonStockerHttpTypes.StoreSellerOfferParams
  >(ROOT_QUERY_KEY)
};
